// extracted by mini-css-extract-plugin
export default {"switchDiv":"Switch_switchDiv__UrNMY","label":"Switch_label__JG4sj"};